export const donutMultiValue = {
  'chart': {
    'type': 'pie',
    'polar': false,
    'margin': [0, 0, 0, 0], //reduces some of the extra white space around each chart
    'height': '70%'
  },
  'plotOptions': {
    'pie': {
      'allowPointSelect': false,
      'cursor': true,
      'innerSize': '50%',
      'dataLabels': {
        'enabled': true
      }
    },
    'series': {
      'animation': true,
      'dataLabels': {
        'enabled': false
      }
    }
  },
  'credits': {
    enabled: false
  },
  'title': {
    'text': ''
  },
  'subtitle': {
    'text': ''
  },
  'exporting': {},
  'series': [
    {
      'name': 'Column 2',
      'turboThreshold': 0,
      '_colorIndex': 0,
      '_symbolIndex': 0,
      'marker': {}
    }
  ],
  'yAxis': {
    'title': {
      'text': 'Units'
    },
    'labels': {}
  },
  'legend': {},
  'tooltip': {
    'formatter': function () {
      return this.key +
        ': <b>' + this.y + '%</b>';
    }
  },
  'xAxis': {
    'title': {},
    'labels': {},
    'opposite': false,
    'type': 'linear'
  }
};
